import {useEffect} from 'react'
import {Navigate, Routes} from 'react-router-dom'
import {useAuth} from './core/Auth'
import {setLanguage} from '../../../_metronic/i18n/Metronici18n'

export function Logout() {
  const {logout} = useAuth()
  useEffect(() => {
    // Reset language to English before logout
    setLanguage('en')
    logout()
    document.location.reload()
  }, [logout])

  return (
    <Routes>
      <Navigate to='/auth/login' />
    </Routes>
  )
}
